import { OptionalFieldTypes } from './state-withholding-la';
import { toCamelCase } from 'BambooHR.util';
import type { OptionalField } from '../../types'

/**
 * Props for the OptionalFields component
 */
export type OptionalFieldsProps = {
    /** string to be prefixed to the component's biId */
    biIdPrefix: string;
    /** ignore, as in ingore filing status and other exemptions. Some fields may be disabled/view-only when ignore is true */
    ignore: boolean;
    /** the optional fields associated a job location */
    optionalFields: {
        byId: {[id: string]: OptionalField};
        allIds: string[];
    };
    /** a map of field types to their corresponding components */
    /** determines whether a field is view-only */
    viewOnly: boolean;
    optionalFieldsMap: OptionalFieldTypes;
};

/**
 * OptionalFields Component
 * 
 * A component that renders optional fields based on their type
 * for state tax withholding.
 */
export const OptionalFields = ({
    biIdPrefix = '',
    optionalFields,
    ignore,
    optionalFieldsMap,
    viewOnly,
}: OptionalFieldsProps) => {
    return (
        <>
            {optionalFields.allIds.map((id) => {
                const field = optionalFields.byId[id];
                
                if (!field) {
                    return null;
                }
                
                const FieldComponent = optionalFieldsMap[field.type];
                if (!FieldComponent) {
                    console.warn(`Unknown field type: ${field.type}`);
                    return null;
                }

                const biId = `${biIdPrefix}-${toCamelCase(field.data.label)}-${id}`;

                if (field.type === "usd" && field.data.label === "Total Allowances") {
                    return (
                        <FieldComponent
                            biId={biId}
                            data={ field.data }
                            help={ field.help }
                            id={ id }
                            isExemption={ true }
                            key={ id }
                            viewOnly={ viewOnly || ignore }
                        />
                    );
                }

                return (
                    <FieldComponent
                        biId={biId}
                        data={ field.data }
                        help={ field.help }
                        id={ id }
                        key={ id }
                        required={ field.required }
                        viewOnly={ viewOnly }
                    />
                );
            })}
        </>
    );
};